var SSSJs = function () {

    return {
        //main function to initiate the module
        init: function () {
            $('#SSSDesc .panel').off('show.bs.collapse').on('show.bs.collapse', function (e) {
                $(this).addClass('acik');
            });

            $('#SSSDesc .panel').off('hide.bs.collapse').on('hide.bs.collapse', function (e) {
                $(this).removeClass('acik');
            });
        }
    };

}();

$(document).ready(function () {
 
    //$('.catalogSliderList').slick({
    //    infinite: true,
    //    autoplay: true,
    //    autoplaySpeed: 3000,
    //    dots: true
    //}),

    //$('.ZeroCatList').slick({
    //    infinite: true,
    //    autoplay: true,
    //    autoplaySpeed: 3000,
    //    dots: true
    //}),

    $('.fancybox-media').fancybox({
        openEffect: 'none',
        closeEffect: 'none',
        helpers: {
            media: {}
        }
    }),

    SSSJs.init();
});